import { Layout } from "antd";
import React from "react";
import LoginForm from "../../components/Forms/LoginForm";

const LoginPage = () => {
  return (
    <Layout>
      <Layout.Content>
        <LoginForm />
      </Layout.Content>
    </Layout>
  );
};

export default LoginPage;
